export default __webpack_public_path__ + "static/media/header-logo.069cf386.svg";